import * as React from "react";
import { useApiService, useTl } from "../../../../hooks";
import { useHistory } from "react-router";
import { useGlobalData } from "../../../../contexts";
import { IDataTableColumn, ButtonContainer } from "nsitools-react";
import { ViewButton, EditButton, SearchTablePage } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { ETLCodes } from "../../../../locales";
import { CharacteristicValuesApi, CharacteristicValuesGridDto, CharacteristicValuesSearch } from "../../../../api";
import { Checkbox } from "@blueprintjs/core";

export interface ICharacteristicValuesListPageProps {}

export const CharacteristicValuesListPage: React.FunctionComponent<ICharacteristicValuesListPageProps> = (props) => {
  const api = useApiService(CharacteristicValuesApi);
  const { t } = useTl();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: CharacteristicValuesGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.characteristicValues}/${row.healthValueId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.characteristicValues}/${row.healthValueId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
      },
      {
        header: () => t(ETLCodes.Laboratory),
        fieldName: "lab",
      },
      {
        header: () => t(ETLCodes.OkForInheritance),
        headerAlignment: "center",
        fieldName: "okForInheritance",
        alignment: "center",
        render: (row: CharacteristicValuesGridDto) => (
          <Checkbox disabled style={{ textAlign: "center" }} checked={row.okForInheritance} />
        ),
      },
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.characteristicValues}/0/detail/edit`);
  }, [history]);
  const search = React.useCallback(
    (sObj) => api.baseSearch(CharacteristicValuesSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );

  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={() => api.getSearchCriterias(true)}
      searchFunction={search}
      exportFunction={(sObj) =>
        api.exportXlsFile(CharacteristicValuesSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId }))
      }
      addFunc={addItemFunction}
      sortKeys={{ name: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.CharacteristicValues) }]}
    />
  );
};
